<template>
  <div class="hp-manager-page-list">
    <filter-from :filter="filter" @handleSubmit="handleSubmit"> </filter-from>
    <standard-table
      ref="datas"
      size="default"
      :bordered="true"
      :columns="columns"
      :dataSource="datas"
      :pagination="pagination"
      :loading="loading"
      @tableChange="tableChange"
    >
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a
            :disabled="!permissionChecker('Credit.Detail')"
            @click="handleDetail(rowKey.data)"
            >往来明细</a
          >
          <a-divider type="vertical" />
          <a
            :disabled="!permissionChecker('Credit.Detail')"
            @click="handleOccupyDetail(rowKey.data)"
            >占用明细</a
          >
          <a-divider type="vertical" />
          <a-popconfirm
            title="请仅在该数据不正确的情况下进行重新同步"
            @confirm="() => reSyncCredit(rowKey.data)"
          >
            <a href="javascript:;">重新同步</a>
          </a-popconfirm>
        </span>
      </template>
    </standard-table>

    <hp-manager-modal
      :title="params.dealerName + '的往来明细'"
      v-model="detailVisible"
      width="1300px"
    >
      <hp-manager-page-credit-detail-list
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="detailVisible = false"
        :paramsX="params"
      ></hp-manager-page-credit-detail-list>
    </hp-manager-modal>

    <hp-manager-modal
      :title="params.dealerName + '的占用明细'"
      v-model="occupyDetailVisible"
      width="1300px"
    >
      <hp-manager-page-occupy-detail-list
        slot="slot"
        @submit-success="refreshCurrent"
        @cancel="occupyDetailVisible = false"
        :paramsX="params"
      ></hp-manager-page-occupy-detail-list>
    </hp-manager-modal>
  </div>
</template>


<script>
import { api } from "@/common";
import filterFrom from "@/components/filter/filter";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import moneyFormat from "@/mixins/moneyFormat";
import { watch } from "fs";
import hpManagerPageCreditDetailList from "./DetailList";
import hpManagerPageOccupyDetailList from "./OccupyDetailList";
import config from "@/config";
import { setTimeout } from "timers";

export default {
  mixins: [account, dateFormat, moneyFormat],
  components: {
    filterFrom,
    hpManagerPageCreditDetailList,
    hpManagerPageOccupyDetailList,
  },
  data() {
    return {
      filter: [
        {
          type: "input",
          key: "dealerName",
          name: "经销商",
        },
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: 240,
          scopedSlots: { customRender: "action" },
          fixed: "left",
        },
        {
          title: "销售组织",
          dataIndex: "organizationName",
          width: 150,
        },
        {
          title: "经销商",
          dataIndex: "dealerName",
          sorter: true,
          //width: 200
        },
        {
          title: "总额度",
          dataIndex: "totalAmount",
          width: 100,
        },
        {
          title: "订单占用",
          dataIndex: "orderOccupy",
          width: 100,
        },
        {
          title: "出库占用",
          dataIndex: "outStockOccupy",
          width: 100,
        },
        {
          title: "可用余额",
          width: 100,
          dataIndex: "availableBalance",
        },
        {
          title: "更新时间",
          dataIndex: "lastModificationTime",
          width: 150,
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          },
        },
      ],
      datas: [],
      filterdata: Object.assign(
        { dealerName: "" },
        JSON.parse(JSON.stringify(config.pageFilter))
      ),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      detailVisible: false,
      occupyDetailVisible: false,
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
  },
  methods: {
    handleSubmit(p) {
      this.pagination.current = 0;
      this.filterdata.dealerName = p.values.dealerName;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },

    handleDetail(record) {
      this.params = record;
      this.detailVisible = true;
      this.occupyDetailVisible = false;
    },
    handleOccupyDetail(record) {
      this.params = record;
      this.detailVisible = false;
      this.occupyDetailVisible = true;
    },
    async reSyncCredit(record) {
      let active = await api.ReSyncCredit({ id: record.id });
      if (active) {
        this.$message.success("提交重新同步成功，请稍后刷新查看");
      }
    },
    refreshCurrent() {
      this.pagination.current = 0;
      this.detailVisible = false;
      this.occupyDetailVisible = false;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },

    async getDatas(options) {
      this.loading = true;
      let data = await api.GetCreditList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = (bbb) => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/router/Basic/Credit/List.vue